import React from 'react';
import './styles.css';
import MobileTableAccordionView, { MobileTableAccordionDataItem, MobileTableAccordionToggle } from 'components/shared/views/MobileTableAccordionView';
import { CustomAccordionClose, CustomAccordionContent, useCustomAccordion } from 'components/custom-ui/CustomAccordion';
import { SVGAsset } from 'res';
import { FormContainer, FormRowView } from 'components/shared';
import { DisabledPrompt, Link, useUIState } from "bcms-react";
import { TransferTransaction } from "model";

/**
 * @function MobilePendingApprovalTable
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The mobile table for pending approval
 */

export default function MobilePendingApprovalTable(props){
  const transfers = props.transfers ?? TransferTransaction.initAll().filter(transfer => transfer.needsApproval, []);
  const transferRows = transfers.map(transfer => {
    return <MobilePendingApprovalItem key={`Mobile_Transfer_${ transfer.id }`} transfer={ transfer } />
  }, []);

  return(
    <div className="mobile-pending-approval-table">
        { transferRows }
    </div>
  );
}


/**
 * @function MobilePendingApprovalItem
 * @return {React.Component}
 * @exported false
 * @description A row for MobilePendingApprovalTable
 */

function MobilePendingApprovalItem(props){
  const transfer = props.transfer ?? TransferTransaction.firstInstanceOf();
  const { key, config } = useUIState(`Mobile_Accordion_${ transfer.id }`, { isActive: false });
  const approveByDate = `${ transfer.approveByDate.format("m/d/Y") } 05:00 PM`;
  const schedule = TransferTransaction.getPendingApprovalTableScheduleMessage(transfer);
  //const scheduleType = transfer.schedule.toLowerCase();
  let nextTransfer = transfer.onDate.format("m/d/Y");

  // May be needed later with full cert support.
  /*if(scheduleType.includes("recurring")) {
      nextTransfer = transfer.startDate.format("m/d/Y");
  }*/

  const scheduleDetails = TransferTransaction.getPendingApprovalTableDetailsScheduleMessage(transfer);

  return(
    <div className="mobile-pending-approval-item">
    <MobileTableAccordionView  active={ config.isActive }>
      <MobileTableAccordionToggle icon="" rightValue={ transfer.amount.format() }>
        <MobileTableAccordionDataItem columnHeader="From:" data={ `${ transfer.from.nickname } - ${ transfer.from.number }` } />
        <MobileTableAccordionDataItem columnHeader="To:" data={ `${ transfer.to.nickname } - ${ transfer.to.number }` } />
        <MobileTableAccordionDataItem columnHeader="Frequency:" data={ schedule } />
        <MobileTableAccordionDataItem columnHeader="Next Transfer:" data={ nextTransfer } />
      </MobileTableAccordionToggle>

      <CustomAccordionContent>
        <div className="custom-accordion-content-container">
          <div className="flex-container custom-accordion-header">
            <p className="flex-width">TRANSFER DETAILS</p>

            <CustomAccordionClose className="set-width clickable">
              <SVGAsset id="CloseX" className="icon" />
            </CustomAccordionClose>
          </div>

          <FormContainer>
            <FormRowView text="Type" className="light-text">
              <p><b>Internal Transfer</b></p>
            </FormRowView>

            <FormRowView text="Deliver By" className="light-text">
              <p><b>{ nextTransfer }</b></p>
            </FormRowView>

            <FormRowView text="Schedule" className="light-text">
              <p><b>{ scheduleDetails }</b></p>
            </FormRowView>

            <FormRowView text="Note" className="light-text">
              <p><b>{ transfer.note }</b></p>
            </FormRowView>

            <FormRowView text="Approve By" className="light-text">
              <p><b>{ approveByDate }</b></p>
            </FormRowView>

            <FormRowView text="Created By" className="light-text">
              <p><b>{ transfer.createdBy.fullName }</b></p>
            </FormRowView>

            <FormRowView className="light-text">
              <DisabledPrompt>
                <Link>
                  Edit Transfer
                </Link>
              </DisabledPrompt>
            </FormRowView>

            <FormRowView className="light-text">
              <DisabledPrompt>
                <Link>
                  Cancel Transfer
                </Link>
              </DisabledPrompt>
            </FormRowView>
          </FormContainer>
        </div>
      </CustomAccordionContent>
    </MobileTableAccordionView>
    </div>
  );
}